module.exports = __webpack_public_path__ + "static/logo3-410b9ae59b255601a3f671ebd7df7a23.png";